<template>
    <Div class="information">
        <div class="login_information white">
            <h1>Hello, Have a Good Day!</h1>
            <div class="block">
                <h2>今日施工單</h2>
                <div class="block_list">
                    <Loading part></Loading>
                    <div v-if="noticeConstruction.length !== 0">
                        <PersonalTable>
                            <table slot="tbody">
                                <colgroup>
                                    <col v-for="(th, index) in thead" :key="index" :width="th.width" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th v-for="(th, th_index) in thead" :key="th_index" :class="th.align == 'center'
                        ? 'text_center'
                        : false
                        ">
                                            {{ th.name }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(
                                            data, index
                                        ) in noticeConstruction">
                                        <tr :key="`application_${index}`">
                                            <template v-for="(th, th_index) in thead">
                                                <!--展開每日施工單-->
                                                <td :class="th.align == 'center'
                        ? 'text_center'
                        : false
                        " :key="`info_${th_index}`" v-if="th.value == 'info'">
                                                    <div class="info_icon" @click="
                        openWork(
                            data,
                            index
                        )
                        ">
                                                        <i class="el-icon-more"></i>
                                                    </div>
                                                </td>
                                                <!--處理department_id-->
                                                <td :key="`department_${th_index}`" v-else-if="th.value ===
                        'new_work.employee.department_id'
                        " :class="th.align == 'center'
                        ? 'text_center'
                        : false
                        ">
                                                    {{
                        transFromDepartmentID(
                            transfromData(
                                data,
                                th.value
                            )
                        )
                    }}
                                                </td>
                                                <!--處理 作業類型-->
                                                <td :key="`type_${th_index}`" v-else-if="th.value === 'type'
                        " :class="th.align == 'center'
                        ? 'text_center'
                        : false
                        ">
                                                    <span v-if="data.type ===
                        '一般作業'
                        ">{{
                        data[th.value]
                    }}</span>
                                                    <ul v-else>
                                                        <li v-for="item in transfromData(
                        data,
                        'op_list[]'
                    )" :key="item">
                                                            {{ item }}
                                                        </li>
                                                    </ul>
                                                </td>
                                                <!--處理 入廠情形-->
                                                <td :key="`work_status_${th_index}`" v-else-if="th.value ===
                        'work_status'
                        " :class="th.align == 'center'
                        ? 'text_center'
                        : false
                        ">
                                                    <template v-if="data.visitors
                        .length > 0 && !check_finishedWork(data.visitors)
                        ">
                                                        <div>已入廠</div>
                                                    </template>
                                                    <template v-else-if="data.visitors
                        .length > 0 && check_finishedWork(data.visitors)">
                                                        <div>已離廠</div>
                                                    </template>
                                                    <template v-else>
                                                        <div>尚未入廠</div>
                                                    </template>
                                                </td>
                                                <td :key="`obj_${th_index}`" v-else-if="Array.isArray(
                        transfromData(
                            data,
                            th.value
                        )
                    )
                        ">
                                                    <p v-for="(
                                                            inner_item, i
                                                        ) in transfromData(
                        data,
                        th.value
                    )" :key="i">
                                                        {{ inner_item }}
                                                        <!-- <span v-if="i + 1 !== transfromData(item.value).length">、</span> -->
                                                    </p>
                                                </td>
                                                <td :key="`default_${th_index}`" v-else>
                                                    {{
                        transfromData(
                            data,
                                                    th.value
                                                    )
                                                    }}
                                                </td>
                                            </template>
                                        </tr>
                                        <!-- <tr
                      class="table_second"
                      :key="`detailed_${index}`"
                      v-if="inner_status && inner_status_index == index"
                    >
                      <td :colspan="thead.length">
                        <div></div>
                      </td>
                    </tr> -->
                                    </template>
                                </tbody>
                            </table>
                        </PersonalTable>
                    </div>
                    <div class="no_data" v-else-if="this.$store.state.loading == false">
                        <i class="el-icon-warning-outline"></i>
                        <p>NO Data</p>
                    </div>
                </div>
            </div>
        </div>
    </Div>
</template>
<style lang="scss">
.information {
    width: 100%;
}

.login_information {
    margin: 0px 10px 30px 10px;
    text-align: left;
    width: 100%;
    padding: 30px;
    border-radius: 8px;

    h1 {
        font-size: 25px;

        font-weight: bold;
    }

    h2 {
        font-weight: bold;
    }

    .block {
        padding-top: 10px;
        margin-top: 10px;
        font-size: 15px;

        h2 {
            padding: 5px 20px;
            width: fit-content;
        }
    }

    .block_list {
        margin: 20px 0 0 0;
        min-height: 340px;

        .item {
            cursor: pointer;
            padding: 10px 5px;
            font-size: 14px;
            border-top: 1px solid var(--lightMainColor2);
            line-height: 20px;

            &.title {
                cursor: auto;
                border-top: none;
                font-weight: bold;
                color: var(--mainColor);

                &:hover {
                    background: transparent;
                }
            }

            >div {

                &:first-child,
                &:nth-child(5) {
                    flex: 1.1;
                }

                padding: 0 8px;
                flex: 2.5;
            }
        }
    }
}

.information_block {
    display: flex;
}

.pink {
    background: #f3adad;

    h1 {
        color: #fff;
    }

    .block {
        color: #fff;
        border-top: 1px dashed #fff;

        h2 {
            background: #fff;
            color: #fa9090;
        }
    }

    .block_list {
        .item {
            &:hover {
                background: #e26464;
            }
        }
    }
}

.white {
    background: #fff;

    h1 {
        color: var(--mainColorHover);
    }

    .block {
        color: var(--fontColor);
        border-top: 1px dashed #ccc;

        h2 {
            background: var(--mainColor2);
            color: #fff;
        }
    }

    .block_list {
        .item {
            &:hover {
                background: var(--lightMainColor2);
            }
        }
    }
}

.table_second {
    &__innerbox {
        .item {
            margin: 10px 20px;
        }

        .independent {
            vertical-align: top;
            display: inline-block;
        }

        .name {
            background: #eaeaea;
            color: #676767;
            padding: 3px 10px;
            border-radius: 3px;
            font-weight: bold;
            margin-bottom: 8px;
        }

        .btn_border {
            padding: 3px 5px;
            border-radius: 5px;
        }

        .inner_name {
            padding-right: 10px;
        }
    }

    &__innerbox__construction {
        padding: 7px 30px;

        &:not(:last-child) {
            border-bottom: 1px dashed #fff;
        }
    }

    &:hover {
        background: #676767 !important;
    }

    background: hsl(0, 0%, 50%);
    color: #fff;
}
</style>
<script>
import * as moment from "moment";
import PersonalTable from "@/components/global/table/PersonalTable.global";
import Options from "@/utils/options";
import { Logger } from "sass";
export default {
    components: { PersonalTable },
    name: "information",
    data() {
        return {
            noticeConstruction: [],
            //2024/4/8切換
            thead: [
                // {
                //   name: "細節",
                //   width:"60px",
                //   value: "info",
                // },
                {
                    name: "施工承攬商",
                    value: "vendor_chinese",
                },
                // {
                //     name: "進場時間",
                //     value: "start_time",
                // },
                // {
                //     name: "離場時間",
                //     value: "end_time",
                // },
                {
                    name: "施工區域",
                    value: "new_work.area",
                },
                {
                    name: "作業類型",
                    value: "type",
                    width: "180px",
                },
                // {
                //     name: "特殊作業",
                //     value: "op_list[]",
                // },
                {
                    name: "承辦單位",
                    value: "new_work.employee.department_id",
                    align: "center",
                },
                {
                    name: "承辦人員",
                    value: "new_work.employee.name",
                    width: "120px",
                },
                {
                    name: "入廠情形",
                    value: "work_status",
                    width: "150px",
                    align: "center",
                },
            ],
            // thead: [
            //     // {
            //     //   name: "細節",
            //     //   width:"60px",
            //     //   value: "info",
            //     // },
            //     {
            //         name: "施工承攬商",
            //         value: "vendor.vendor_chinese",
            //     },
            //     {
            //         name: "進場時間",
            //         value: "starttime",
            //     },
            //     {
            //         name: "離場時間",
            //         value: "endtime",
            //     },
            //     {
            //         name: "作業類型",
            //         value: "type",
            //     },
            //     {
            //         name: "特殊作業",
            //         value: "op_id[]",
            //     },
            // ],

            options: {
                area: [],
                area_key: "location",
                area_value: "id",
                op: [],
                op_value: "op_id",
                op_key: "op_name",
                department: [],
            },
            inner_status: false,
            inner_status_index: null,
        };
    },
    computed: {
        today() {
            return moment().format("YYYY-MM-DD");
        },
        transFromDepartmentID() {
            return function (id) {
                const department = this.options.department.find((el) => {
                    return el.department_id === id;
                });
                return department.department;
            };
        },
        check_finishedWork() {
            return function (item) {
                const result = [];
                item.map((el) => {
                    if (el.out_time === null) {
                        result.push(false)
                    } else {
                        result.push(true)
                    }
                })
                if (result.includes(false)) {
                    return false
                } else {
                    return true
                }
            }
        }
    },
    async created() {
        this.$store.commit("loadingAction", null);
        this.options.area = await Options.getArea();
        this.options.op = await Options.getSpecialOperation();
        //取得部門清單
        this.options.department = await Options.getDepartment();
        this.getData();
    },
    methods: {
        getData() {
            this.$store.commit("loadingAction", true);
            // this.$http.api.vendor
            //     .getDailyConstruction({
            //         start_date: this.today,
            //         end_date: this.today,
            //     })
            //     .then((res) => {
            //         this.noticeConstruction = res.data.filter((el) => {
            //             return el.status == "同意";
            //         });
            //         this.$store.commit("loadingAction", false);
            //     });
            //2024/4/8 切換到新的api
            this.$http.api.vendor.getNewDailyConstruction().then((res) => {
                //console.log(res.data);
                this.noticeConstruction = res.data.filter((el) => {
                    //console.log(el);
                    return el.new_work.status == "同意";
                });
                this.$store.commit("loadingAction", false);
            });
        },
        contractorDetialed(item) {
            this.$router.push({
                name: "construction_detailed",
                query: {
                    id: item.construction_serial,
                },
            });
        },
        openWork(data, index) {
            if (
                this.inner_status_index !== null &&
                this.inner_status_index == index
            ) {
                //代表已經開啟且同一個，要關閉
                this.inner_status = false;
                this.inner_status_index = null;
            } else {
                this.inner_status = true;
                this.inner_status_index = index;
            }
        },
        // transfromData(data, th) {
        //     if (th.includes("[]") && th.includes(".")) {

        //         const innerKey = th.split("[]");
        //         const lastKey = innerKey[1].split(".")[1];
        //         return data[innerKey[0]].map((el) => {
        //             return el[lastKey];
        //         });
        //     } else if (th.includes(".")) {
        //         const innerKey = th.split(".");

        //         return data[innerKey[0]][innerKey[1]];
        //     } else {
        //         return data[th]
        //     }
        // },
        //2024/4/8切換
        transfromData(data, th) {
            if (th.includes(".")) {
                const innerKey = th.split(".");
                if (innerKey.length < 3) {
                    return data[innerKey[0]][innerKey[1]];
                } else {
                    return data[innerKey[0]][innerKey[1]][innerKey[2]];
                }
            } else if (th.includes("[]")) {
                //console.log(th, data);
                //特殊作業
                const innerKey = th.split("[]")[0];
                //console.log('innerKey:', innerKey);
                let options = [];
                let options_key = null;
                for (let option_key in this.options) {
                    if (innerKey.includes(option_key)) {
                        //console.log(innerKey.includes(option_key));
                        options = this.options[option_key];
                        options_key = option_key;
                        // console.log("options:", options);
                        //console.log("options_key:", options_key);
                    }
                }

                //2024/4/8切換
                return options
                    .filter((el) => {
                        // console.log('innerKey', innerKey);
                        //console.log('el:', el);
                        // console.log(data[innerKey]);
                        //console.log(el[this.options[`${options_key}_key`]]);
                        return data[innerKey].includes(
                            el[this.options[`${options_key}_key`]]
                        );
                    })
                    .map((el) => {
                        return el[this.options[`${options_key}_key`]];
                    });
            } else {
                //console.log('data[th]:', data[th]);
                return data[th];
            }
        },
    },
};
</script>
